<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-06 10:53:41
 * @LastEditTime: 2019-08-15 15:18:25
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="container">
        <div class="pageTitle">
            
1、返利根据订货经销商的订货价与直属上级经销商的订货价之间的差价进行计算，并且返利会逐级往上返，直到上级为总部为止，但如果直属上级的订货价大于或等于订货经销商的订货价时，则不进行返利；
<br/>
2、返利会在过了系统设置的返利期限之后到账；<span  @click='link'>前往设置返利期限>></span>
<br/>
3、赠品下单后不会进行返利。
        </div>
        <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
            <el-form-item label="到账时间:" style="text-align: center">
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="开始时间" v-model="form.start_time"
                                    style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="结束时间" v-model="form.end_time"
                                    style="width: 100%;"></el-date-picker>
                </el-col>
            </el-form-item>
            <el-form-item label="经销商:">
                <el-col :span="16">
                    <el-input v-model="form.dealer_sn" clearable></el-input>
                </el-col>
                <el-col :span="4" style="margin-left: 10px;">
                    <el-button type="primary" @click="selectType()">选择</el-button>
                </el-col>
            </el-form-item>
            <el-form-item label="订单号:">
                <el-input v-model="form.settlement_order_sn" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="search()">搜索</el-button>
                <el-button @click="exportList()">导出</el-button>
            </el-form-item>
        </el-form>
        <el-row >
            <span>返利总额：</span> <span style="color: red">{{all}}元</span>
        </el-row>
            <br/>
        <!--表格-->
        <el-table
                ref="multipleTable"
                :data="tableData"
                border
                stripe
                height="350"
                style="width: 95%">
            <el-table-column
                    prop=""
                    label="返利经销商"
            >
            <template slot-scope="scope">
                <el-tooltip placement="right" effect="light">
                <div slot="content">
                    <ul>
                        <li style='margin-bottom:10px;'><span>
                        经销商级别:{{scope.row.dealer_level_name}}
                            </span></li>
                            <li style='margin-bottom:10px;'><span>
                        负责人:{{scope.row.dealer_person}}
                            </span></li><li style='margin-bottom:10px;'><span>
                        手机号码:{{scope.row.dealer_mobile}}
                            </span></li><li style='margin-bottom:10px;'><span>
                        详细地址:{{scope.row.dealer_address}}
                            </span></li><li style='margin-bottom:10px;'><span>
                        上级经销商:{{scope.row.superior_dealer_name}} <span v-if="scope.row.superior_dealer_sn!=0&&scope.row.superior_dealer_name!='总部'">({{scope.row.superior_dealer_sn}})</span>
                            </span></li>
                    </ul>
                </div>
                <span> {{scope.row.dealer_name}}({{scope.row.dealer_sn}})</span>
                </el-tooltip>
              
                </template>
            </el-table-column>
            <el-table-column
                    prop=""
                    label="相关订单号"
            >
                <template slot-scope="scope">
                    <span    @click='sn_detail(scope.row)' style="color:blue;cursor: pointer">
                        {{scope.row.settlement_order_sn}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="created_at"
                    label="到账时间"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="settlement_money"
                    label="返利金额(元)"
                    show-overflow-tooltip>
            </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize">
        </el-pagination>
        <!--选择经销商-->
        <selectRole
                v-if="selectRoleDialog"
                v-on:handleClose='selectRoleDialog = false'
                @pushData='selectDone'>
        </selectRole>
    </div>
</template>

<script>
    import selectRole from '../../common/selectDealer';
    export default {
        name: "rebate-issue",
        data() {
            return {
                selectRoleDialog:false,
                form: {
                    dealer_sn: '',
                    settlement_order_sn: '',
                    start_time: '',
                    end_time: '',
                },
                tableData: [
                    {},
                    {},
                ],
                instockDetailDialogVisable:false,
                stock_in_sn:'',//查看明细传递的入库单号
                //分页
                pageNo: 1,
                pageSize: 10,
                totalSize: 0,
                loading:false,
                all:0
            }
        },
        methods: {
            search(){
                      if (this.form.start_time) {
                    this.form.start_time = this.moment(this.form.start_time).format("YYYY-MM-DD");
                }
                if (this.form.end_time) {
                    this.form.end_time = this.moment(this.form.end_time).format("YYYY-MM-DD");
                }
                this.$get('logistics','/dealers.rebates.logs',{
              
                  ...this.form
                }).then(res=>{
                    this.rebate_total=res.rebate_total
                    this.totalSize=res.meta.total
                    this.tableData=res.data
                    this.all=res.rebate_total
                   
                })
            },
            getList(){
              
                if (this.form.start_time) {
                    this.form.start_time = this.moment(this.form.start_time).format("YYYY-MM-DD");
                }
                if (this.form.end_time) {
                    this.form.end_time = this.moment(this.form.end_time).format("YYYY-MM-DD");
                }
                this.$get('logistics','/dealers.rebates.logs',{
                  page:this.pageNo  ,
                  per_page:this.pageSize,
                  ...this.form
                }).then(res=>{
                    this.rebate_total=res.rebate_total
                    this.totalSize=res.meta.total
                    this.tableData=res.data
                    this.all=res.rebate_total
                   
                })
            },
            selectType(){
                this.selectRoleDialog = true;

            },
          
            handleSizeChange(val){
                 this.pageSize=val
         
                this.getList()
            },
            handleCurrentChange(val){
                this.pageNo=val
                this.getList()
            },
            selectDone(val){
                this.form.dealer_sn=val.dealer_sn
            },
             exportList(){
                // localStorage.setItem('access_tokens','eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Ijg2MWFkZTk2OGZhM2RlODFhZmY4ZGY1MTBhNGZiZmM2ZDE4ZDE5NjU2ZWRkNWYyNDAyN2JiNjQ4ZjAxYTg4OTI4MTNkMzI1OTBjODUzOTMyIn0.eyJhdWQiOiIxMDA4ODAwMyIsImp0aSI6Ijg2MWFkZTk2OGZhM2RlODFhZmY4ZGY1MTBhNGZiZmM2ZDE4ZDE5NjU2ZWRkNWYyNDAyN2JiNjQ4ZjAxYTg4OTI4MTNkMzI1OTBjODUzOTMyIiwiaWF0IjoxNTYyNzU5MjczLCJuYmYiOjE1NjI3NTkyNzMsImV4cCI6MTU2NDA1NTI3Mywic3ViIjoiMjIiLCJzY29wZXMiOlsiKiJdfQ.NsIp_fAqXcOn4osyLQ6fTxVTiqUt2ah9LL30AJnWoBdmDTOerX5myrW75Vtkz1obu8XhwA2zKzz1Toy1jDfeWC0DmpK7R6LvqeumckjombxVK979uCQHu3l0InUJ25_IiD99Br9oSNEIV2zIUGaQsCmxqCmOzgEwn8AYX2PyQamcZLFhew-F-aOUDYvHWoduXV401gtCOAEDZR5LbJsLSZJ00rp06qg-QkXiQYwYRQ90rRJXyL3BHII1Bl9bmzLRZ_LD_EHA_BLN_6ZSdAuzqLHh5UK6P2Q1UNkM0YH8LOIiMpVneWjlpkhI55GBZfTTPkCu5HLE7GXx4bjZk5En99vtLUYR8ACcaJeY4a1LjH8SCvaDKcj3eVk8OpPD4-P3qzT6rmyOceymCxzqVMXknZO0PN3yjEg9-KJiHCIQIXJ3Qy_rR1eq5gxLhYmYmkKNxwS8HEcttyezj1M93YG3ewB0cAJA9O9DL2RwY2jhTnQel3UAzG0vjnEK_oH-SctRse38pMt6F_yyDa2EO22utHrysCSI7rRVA9xADFUth2C333cPsmZ2dmKxup_hZGlncINxjs8hUQQ_jWDmNrELe2fm9_n13uvVVeIYmeqs4H9l7Z2uZxWZOr7kNYF3FUTa37hp2LiOt8hCvuCc9qDbE8ur-Ed9BbR5rzTZltgGIo4')
                let beginstr = "",
                endstr = "";
            var page='' ,per_page='',obj={}
           
            if (this.form.start_time) {
                beginstr = this.moment(obj.start_time).format("YYYY-MM-DD");
            }
            if (this.form.end_time) {
                endstr = this.moment(obj.end_time).format("YYYY-MM-DD");
            }
            let url = "",
                access_tokens = localStorage.getItem("access_tokens");
        
      
      window.open(
       this.$Base_Export+
            "/dealers.rebates.logs.export?start_time=" +
            beginstr +
            "&end_time=" +
            endstr +
            "&is_export="+
            1+
            "&lang=" +
            "" +
            '&page='+page+
            '&per_page='+per_page+
            "&settlement_order_sn=" +
            this.form.settlement_order_sn+
            "&dealer_sn=" +
            this.form.dealer_sn +
            "&signature=" +
            this.$md5(access_tokens)
        );
                },
                link(){
                   
                    this.$router.push({
                        name:'basicSetting',
                        query:{
                            order:1
                        }
                    })
                },
                sn_detail(sn){
                    this.$router.push({
                        name:'dealerOrder',
                        query:{
                            sn:sn.settlement_order_sn,
                            is_parent:2
                        }
                    })
                }
        },
        created() {
            this.getList()
        },
        components:{
            selectRole
        }
    }
</script>

<style lang="scss" scoped>
.pageTitle{
    height: auto;
    span{
        color: rgb(88, 182, 251)
    }
}
</style>